import { crmRequest } from '@meta-vue/util'

export const getJumpSwitchConfig = async () => {
  // try {
  //   const data = await crmRequest('/cust-complain-app/complaint/sysConfig/getByItem', {
  //     method: 'get',
  //     params: {
  //       item: 'H5newcallcenterJumpToCSWorkbench'
  //     },
  //     silent: true
  //   })
  //   if (data && typeof data === 'string') {
  //     // 约定数据必须是json字符串，其他任何类型都返回默认值
  //     return JSON.parse(data)
  //   }
  // } catch (error) {
  //   console.log('getJumpSwitchConfig error', error)
  //   return {} // 报错就返回默认数据
  // }
}
